export const TYPE_SECTION = {
  RECENT: 'recent',
  EARLIER: 'earlier',
};
export const STATUS = {
  READ: 'READ',
  UN_READ: 'UNREAD',
};
export default TYPE_SECTION;
